import React from 'react';

export interface WizardStepProps {
  stepId: string;
  title: string;
  subtitle?: string;
  isActive: boolean;
  children: React.ReactNode;
}

export function WizardStep({ title, subtitle, isActive, children }: WizardStepProps) {
  if (!isActive) return null;

  return (
    <div className="p-6">
      <div className="max-w-3xl mx-auto">
        <div className="mb-8 text-center">
          <h2 className="text-2xl font-bold text-gray-900 mb-2">{title}</h2>
          {subtitle && (
            <p className="text-gray-600">{subtitle}</p>
          )}
        </div>
        
        <div className="space-y-6">
          {children}
        </div>
      </div>
    </div>
  );
}